/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This may be the first race of the season or data hasn't been loaded yet.`)
};

const es_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta puede ser la primera carrera de la temporada o los datos aún no se han cargado.`)
};

const de_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies könnte das erste Rennen der Saison sein oder die Daten wurden noch nicht geladen.`)
};

const nl_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit kan de eerste race van het seizoen zijn of de gegevens zijn nog niet geladen.`)
};

const fr_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela peut être la première course de la saison ou les données n’ont pas encore été chargées.`)
};

const it_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrebbe essere la prima gara della stagione o i dati non sono ancora stati caricati.`)
};

const pt_br2_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta pode ser a primeira corrida da temporada ou os dados ainda não foram carregados.`)
};

const pt_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta pode ser a primeira corrida da época ou os dados ainda não foram carregados.`)
};

const ja_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズン最初のレースか、データがまだ読み込まれていない可能性があります。`)
};

const zh_f1_budget_no_data_detail = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这可能是本赛季第一场比赛，或数据尚未加载。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_no_data_detail = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_no_data_detail(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_no_data_detail", locale)
	if (locale === "en") return en_f1_budget_no_data_detail(inputs)
	if (locale === "es") return es_f1_budget_no_data_detail(inputs)
	if (locale === "de") return de_f1_budget_no_data_detail(inputs)
	if (locale === "nl") return nl_f1_budget_no_data_detail(inputs)
	if (locale === "fr") return fr_f1_budget_no_data_detail(inputs)
	if (locale === "it") return it_f1_budget_no_data_detail(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_no_data_detail(inputs)
	if (locale === "pt") return pt_f1_budget_no_data_detail(inputs)
	if (locale === "ja") return ja_f1_budget_no_data_detail(inputs)
	return zh_f1_budget_no_data_detail(inputs)
};